comunidade.component('comunidade.comunidadeComponent', {
    templateUrl: 'comunidade/comunidade.html',
    controller: 'comunidade.comunidadeController',
    controllerAs: '$ctrl'
});

comunidade.controller('comunidade.comunidadeController', ["$rootScope", '$scope', '$state', 'coreFb', function($rootScope, $scope, $state, $fb){
    const $ctrl = this;

    const _getAreaMembros=(idArea)=>{

        $fb.db.get(`cad_areaMembros/${idArea}`).then(doc=>{
            $ctrl.comunidade = doc.data.comunidade;
            $state.params.showGlobalLoading = false;

        }).catch(e=>{
            console.log(e);
        });
    };

    $ctrl.$onInit = () => {
        let idAreaMembros = $fb.auth.getIdToken().claims.idAreaMembros;
        
        _getAreaMembros(idAreaMembros);
        $scope.isDesktop = $rootScope.isDesktop;
    }

}]);